export const lineHeights = {
  base: 1.5,
  short: 1.3,
};
